import React, { useState } from "react";
import DayPickerNew from "./DayPickerNew";

const DayPickerNewExample: React.FC = () => {
	const [date, setDate] = useState<Date | undefined>(new Date());
	const [empty, setEmpty] = useState<Date | undefined>();
	const [locked] = useState<Date | undefined>(new Date());

	return (
		<div className="max-w-md space-y-8 p-6">
			<h3 className="text-lg font-semibold">DayPickerNew</h3>
			<p className="text-sm text-gray-600">
				Tailwind/shadcn replacement for the styled-components DayPicker. Same calendar, but the
				popover is Radix so it portals out of overflow and stacking contexts.
			</p>

			<div>
				<h4 className="mb-2 font-medium">With label and description</h4>
				<DayPickerNew
					value={date}
					onChange={setDate}
					label="invoiceBatch.to"
					description="invoiceBatch.toDescription"
				/>
			</div>

			<div>
				<h4 className="mb-2 font-medium">Empty, with placeholder</h4>
				<DayPickerNew value={empty} onChange={setEmpty} placeholder="SELECT_DATE" />
			</div>

			<div>
				<h4 className="mb-2 font-medium">Disabled</h4>
				<DayPickerNew value={locked} label="invoice.invoiceDate" disabled />
			</div>

			<div>
				<h4 className="mb-2 font-medium">Constrained width</h4>
				<DayPickerNew value={date} onChange={setDate} containerClassName="w-48" />
			</div>
		</div>
	);
};

export default DayPickerNewExample;
